import { pagedList } from './pagedList';
import { del, get, searchAllPages, post, postAllPages } from '@/lib/apiClient';
import { endpoints } from './endpoints';
import { rememberSchoolBranches, rememberSchoolList, schoolScope } from './schoolScope';
import type { SchoolContact, SchoolContactInput, SchoolInput, SchoolRecord } from '@/models';

const f = endpoints.foundation;

// --- Schools ---------------------------------------------------------------

/** Every school of the caller's organization (and branch, when branch-scoped). */
// Every school read here is remembered with its branch, for the branch-scoped routes (schoolScope).
const remembered = <T extends SchoolRecord | SchoolRecord[]>(result: T): T => {
  rememberSchoolBranches(Array.isArray(result) ? result : [result]);
  return result;
};

export const listSchools = async () => {
  const schools = await postAllPages<SchoolRecord>(f.schoolSearch);
  rememberSchoolList(schools);
  return schools;
};
export const getSchool = async (schoolId: number) => remembered(await get<SchoolRecord>(f.school(schoolId)));
export const createSchool = async (input: SchoolInput) => remembered(await post<SchoolRecord>(f.schools, input));
export const updateSchool = async (schoolId: number, input: SchoolInput) =>
  remembered(await post<SchoolRecord>(f.school(schoolId), input));

// --- School contacts -------------------------------------------------------

export const listSchoolContacts = async (schoolId: number) =>
  searchAllPages<SchoolContact>(f.schoolContacts(), {}, await schoolScope(schoolId));
export const createSchoolContact = async (schoolId: number, input: SchoolContactInput) =>
  post<SchoolContact>(f.schoolContacts(), input, await schoolScope(schoolId));
export const updateSchoolContact = async (schoolId: number, schoolContactId: number, input: SchoolContactInput) =>
  post<SchoolContact>(f.schoolContact(schoolContactId), input, await schoolScope(schoolId));
export const deleteSchoolContact = async (schoolId: number, schoolContactId: number) =>
  del<void>(f.schoolContact(schoolContactId), await schoolScope(schoolId));

// Server-driven table lists.
export const listSchoolContactsPage = pagedList<SchoolContact>(f.schoolContacts());
